// extracted by mini-css-extract-plugin
export var container = "_gv-0";
export var segment = "_gv-2";
export var segmentActive = "_gv-3";
export var track = "_gv-1";